var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { store } from '../../store/app.store';
import GridViewComponent from '../GridViewComponent/GridViewComponent';
import { FlightingService } from '../../services/Flighting.Service';
import { EmptyState, EmptyStateIconType } from '@verge-vcl-react/empty-state';
import { styles } from '../GridViewComponent/GridViewComponent.styles';
import { TelemetryService } from '../../services/TelemetryService';
import { EventCodes, TelemetryFeatures, TelemetryActions } from '../../../common/TelemetryConstants';
const AvailabilityViewComponent = () => {
    const telemetryService = TelemetryService.getInstance();
    const [isFeatureEnabled, setIsFeatureEnabled] = useState(null);
    useEffect(() => {
        const flightingService = FlightingService.getInstance();
        flightingService.evaluateFeatureFlag(['CESEditAssignment'])
            .then((result) => {
            setIsFeatureEnabled(Boolean(result === null || result === void 0 ? void 0 : result.CESEditAssignment));
        })
            .catch((error) => {
            setIsFeatureEnabled(false);
        });
    }, []);
    // Track traffic source and page visit
    useEffect(() => {
        if (isFeatureEnabled === true) {
            const correlationId = telemetryService.getCorrelationId();
            const properties = telemetryService.createPropertyBag();
            // Check if user came with start-date in URL
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.includes('?') ? hash.split('?')[1] : '');
            const startDateParam = params === null || params === void 0 ? void 0 : params.get('start-date');
            if (startDateParam && !isNaN(Date.parse(startDateParam))) {
                // User came with start date in URL
                properties.addToBag('source', 'StartDateInUrl');
                properties.addToBag('startDate', startDateParam);
                properties.addToBag('timestamp', new Date().toISOString());
                telemetryService.logEvent(TelemetryFeatures.EditAvailability, TelemetryActions.TrafficSource, EventCodes.Ev0003, properties, correlationId);
            }
            else {
                // User came from edit availability navigation
                properties.addToBag('source', 'EditAvailability');
                properties.addToBag('timestamp', new Date().toISOString());
                telemetryService.logEvent(TelemetryFeatures.EditAvailability, TelemetryActions.TrafficSource, EventCodes.Ev0004, properties, correlationId);
            }
            // Log page visit
            const pageVisitProperties = telemetryService.createPropertyBag();
            pageVisitProperties.addToBag('page', 'EditAvailability');
            pageVisitProperties.addToBag('timestamp', new Date().toISOString());
            pageVisitProperties.addToBag('userAgent', navigator.userAgent);
            telemetryService.logEvent(TelemetryFeatures.EditAvailability, TelemetryActions.PageVisit, EventCodes.Ev0002, pageVisitProperties, correlationId);
            // Log page load completion
            telemetryService.logPageView('EditAvailability.PageLoad', {
                feature: 'EditAvailability',
                loadTime: Date.now(),
                timestamp: new Date().toISOString()
            });
        }
    }, [isFeatureEnabled, telemetryService]);
    // const dispatch = useAppDispatch();
    // useEffect(() => {
    //   /* Setup UX Config */
    //   const config = GenerateConfig();
    //   dispatch(RA_SETUP_UXCONFIG(config));
    // }, [dispatch]);
    return (isFeatureEnabled ? (React.createElement(Provider, { store: store },
        React.createElement(GridViewComponent, null))) : (React.createElement(EmptyState, { type: EmptyStateIconType.NOT_FOUND, isDescriptionLinkUrlOpenInNewTab: true, headingText: "Feature not available", descriptionText: "", headingLevel: "h2", styles: styles.emptyStateStyles })));
};
export default AvailabilityViewComponent;
//# sourceMappingURL=AvailabilityView.js.map